<template #default="{ errorMessages }">
    <div elevation="0" ref="formContainer">
        <v-row justify="center" class="text-center" v-if="loadingCompanies">
            <v-col>
                <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
            </v-col>
        </v-row>

        <v-row justify="space-between" v-if="!loadingCompanies">
            <v-col align-self="center" class="mb-0 pb-0">
                <p class="mb-0 font-weight-bold body-1">Notificar a Todas las empresas</p>
            </v-col>
            <v-col
                class="text-right justify-end mb-0 pb-0 just-items-end mr-0 pr-6"
                align-self="center"
            >
                <v-checkbox v-model="allSelected"></v-checkbox>
            </v-col>
        </v-row>

        <v-row v-if="!loadingCompanies">
            <v-col class="px-4">
                <v-card
                    v-for="(item, i) in values.businessData"
                    :key="i"
                    class="questionnaires-business-list mb-2"
                >
                    <template>
                        <v-expansion-panels flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header
                                    class="pl-3 pr-3"
                                    @click="loadEmployees(item)"
                                >
                                    {{ item.businessName }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <table-items
                                        :props="companyTable"
                                        @methodHandler="method_handler"
                                        :items="item.employees"
                                        :valueInput="item.employees_notified"
                                        @valueChange="
                                            (v) => {
                                                item.employees_notified = v;
                                                inspectCheck(item);
                                            }
                                        "
                                    >
                                     <template v-slot:body="{ items, isSelected, select}">
                                        <tbody>
                                          <tr v-for="d in items" :key="d.id" :class="d.hasAnswers ? 'inputsBackground' : ''">
                                            <td>
                                              {{ d.name }}
                                            </td>
                                             <td>
                                              <v-checkbox
                                                :input-value="isSelected(d)"
                                                style="margin:0px;padding:0px"
                                                color="primary"
                                                hide-details
                                                @click="select(d,!isSelected(d))"
                                                :disabled="d.hasAnswers"
                                              >                   
                                              </v-checkbox>
                                            </td>
                                            
                                          </tr>
                                        </tbody>
                                      </template>
                                    </table-items>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </template>
                    <v-checkbox
                        v-model="item.selectedBusiness"
                        class="px-2"
                        :ripple="false"
                        @click="allEmployeesCheck(item)"
                    ></v-checkbox>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'surveyId'],

    model: {
        event: 'tabChanged',
    },

    computed: {},
    data() {
        return {
            loadingCompanies: false,
            allSelected: false,
            questionsIndex: [],
            someEmployeeRemoved: 0,
            loadingEmployee: false,
            employeeSelected: '',

            serverItems: {
                companies: [],
            },

            companyTable: {
                headers: [
                    {
                        text: 'Colaboradores a notificar',
                        align: 'left',
                        value: 'name',
                        class: 'table-b-border body-1 font-weight-bold',
                        sortable: false,
                    },

                    {
                        text: '',
                        align: 'right',
                        sortable: false,
                        value: 'data-table-select',
                        class: 'table-b-border',
                    },
                ],
                items: [],
                search: '',
                loading: false,
                showSelect: true,
                key: 'id',
                showSelect: true,
            },
        };
    },
    watch: {
        allSelected: function (v) {
            console.log(v, this.values.businessData);

            this.values.businessData.forEach((b) => {
                b.selectedBusiness = v;
                this.allEmployeesCheck(b);
            });
            this.values.employees = [];
        },
    },
    async mounted() {
        this.generateQuestionsIndexList();
        await this.getCompanies();
    },
    methods: {
        method_handler(object) {
            this[object.method_name](object.parameters);
        },
        inspectCheck(item) {
            if (item.employees.length > item.employees_notified.length)
                item.selectedBusiness = false;
            if (item.employees.length == item.employees_notified.length)
                item.selectedBusiness = true;
            this.values.employees = this.values.employees.filter(
                (x) => x.businessId != item.businessId,
            );
            if(item.employees_notified.length == 0){
              item.employees_notified = item.employees.filter((x) => x.hasAnswers)
            }
        },
        /**
         * load companies
         */
        getCompanies() {
            this.loadingCompanies = true;
            this.$api.user
                .getUserBusinessSelect()
                .then((resp) => {
                    console.log(resp, 'desde form');
                    this.values.businessData = resp.data.map((x) => {
                        return {
                            loading: false,
                            businessId: x.id,
                            businessName: x.name,
                            employees: [],
                            employees_notified: [],
                            selectedBusiness: false,
                        };
                    });

                    if (this.edit) {
                        this.setBusinessData();
                    }
                })
                .catch((error) => {
                    console.log(error, 'error desde form areas');
                })
                .finally(() => {
                    this.loadingCompanies = false;
                });
        },
        setBusinessData() {
            console.log('run set business');
            for (let i = 0; i < this.values?.apply_for?.length; i++) {
                let found = this.values.businessData.find(
                    (x) => x.businessId == this.values.apply_for[i].id,
                );
                if (found != undefined) {
                    found.selectedBusiness = true;
                }
            }

            if (this.values.apply_for.length == this.values.businessData.length)
                this.allSelected = true;
        },
        allEmployeesCheck(item) {
            console.log(item, 'allEmployeesCheck');
            item.employees_notified = [];
            this.values.employees = this.values.employees.filter(
                (x) => x.businessId != item.businessId,
            );
            if (item.selectedBusiness) {
                item.employees_notified = item.employees.map((x) => {
                    return x;
                });
            }else{
              item.employees_notified = item.employees.filter((x) => x.hasAnswers)
            }
            console.log(this.values.employees, 'allEmployeesCheck final final');
        },

        loadEmployees(item) {
            if (item.employees.length > 0) return;

            this.companyTable.loading = true;
            item.loading = true;
            this.$api.questionaries
                .getPendingEmployeesByCompany(this.surveyId, item.businessId)
                .then((respNoUsers) => {
                    //get employees with users
                    this.$api.questionaries
                        .getPendingEmployeesWithUserByCompany(this.surveyId, item.businessId)
                        .then((respWithUser) => {
                            const responseEmployees = [];
                            // responseEmployees.push(...respNoUsers.data);
                            responseEmployees.push(...respWithUser.data);

                            responseEmployees.sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
                            );

                            item.employees = responseEmployees.map((x) => {
                                return {
                                    id: x.id,
                                    name: x.name,
                                    email: x.email,
                                    businessId: item.businessId,
                                    businessName: item.businessName,
                                    hasAnswers: x.has_answers ?? false,
                                };
                            });

                            if (item.selectedBusiness) {
                                item.employees_notified = responseEmployees.map((x) => {
                                    return {
                                        id: x.id,
                                        name: x.name,
                                        email: x.email,
                                        businessId: item.businessId,
                                        businessName: item.businessName,
                                        hasAnswers: x.has_answers ?? false,
                                    };
                                });
                            }

                            if (this.edit) {
                                for (let i = 0; i < this.values.employees.length; i++) {
                                    const found = item.employees_notified.find(
                                        (x) => x.id == this.values.employees[i].id,
                                    );
                                    const found2 = item.employees.find(
                                        (x) => x.id == this.values.employees[i].id,
                                    );
                                    if (found == undefined && found2 != undefined) {
                                        item.employees_notified.push(this.values.employees[i]);
                                    }
                                }
                            }

                            //autocheck
                            let fullList = true;
                            item.employees.forEach((em) => {
                                const found = item.employees_notified.find((x) => x.id == em.id);
                                if (found == undefined) fullList = false;
                            });

                            item.selectedBusiness = fullList;

                            console.log(item);
                        })

                        .catch((error) => {
                            console.log(error);
                        })
                        .finally(() => {
                            item.loading = false;
                            this.companyTable.loading = false;
                        });
                })
                .catch((error) => {
                    console.log(error, 'error eventForm');
                })
                .finally(() => {
                    // item.loading = false;
                    // this.companyTable.loading = false;
                });
        },

        /**
         * Create a list of questions
         * use with "salto de pregunta"
         */
        generateQuestionsIndexList() {
            this.questionsIndex = [];
            for (let i = 0; i < this.values.questions.length; i++) {
                this.questionsIndex.push({ text: `Pregunta ${i + 1}`, value: i });
            }
        },

        sendValues(questions = null) {
            this.$emit('updateValues', { questions: this.values.questions });
        },
    },
};
</script>

<style lang="scss">
.tab {
    &-header {
        font-size: 12px !important;
        color: var(--v-normalText-lighten4) !important;
    }

    &-active {
        color: var(--v-normalText-base) !important;
    }

    &-error {
        color: var(--v-warning-base) !important;
    }
}
.less-margin {
    margin-bottom: -20px;
}

.fab-questionary {
    right: 10% !important;
    bottom: 10% !important;
}

.just-items-end {
    justify-items: flex-end;
}

.questionnaires-business-list {
    display: flex;
    align-items: baseline;
}
</style>
